import { Link } from "react-router-dom";
import { WarningCircle, HardHat } from "@phosphor-icons/react";

/** "No RAMS" / "RAMS draft" pill for scheduled jobs & emergency jobs (warn-only). Renders nothing when a RAMS is issued or the job isn't dispatchable yet. */
export default function RamsFlag({ status, ramsId, testId = "rams-flag", size = "xs", className = "" }) {
  if (status !== "missing" && status !== "draft") return null;
  const pad = size === "xs" ? "px-1.5 py-0.5 text-[10px]" : "px-2.5 py-1 text-xs";
  if (status === "draft") {
    const body = <><HardHat size={size === "xs" ? 10 : 12} weight="fill" /> RAMS draft</>;
    const cls = `inline-flex items-center gap-1 rounded-full font-semibold whitespace-nowrap bg-amber-100 text-amber-800 dark:bg-amber-500/20 dark:text-amber-200 ${pad} ${className}`;
    return ramsId
      ? <Link to={`/health-safety/rams/${ramsId}`} onClick={e => e.stopPropagation()} className={`${cls} hover:bg-amber-200 dark:hover:bg-amber-500/30`} title="A RAMS is drafted but not yet issued — open it to finish and issue" data-testid={`${testId}-draft`}>{body}</Link>
      : <span className={cls} title="A RAMS is drafted but not yet issued" data-testid={`${testId}-draft`}>{body}</span>;
  }
  return (
    <span className={`inline-flex items-center gap-1 rounded-full font-semibold whitespace-nowrap bg-red-100 text-red-700 dark:bg-red-500/20 dark:text-red-200 ${pad} ${className}`}
      title="This job is scheduled or crewed but has no RAMS — create one from the job page before the crew is on site" data-testid={`${testId}-missing`}>
      <WarningCircle size={size === "xs" ? 10 : 12} weight="fill" /> No RAMS
    </span>
  );
}
